import users from '@/store/modules/users/users'
import createUser from '@/store/modules/users/user-create'
import editUser from '@/store/modules/users/user-edit'

export default {
  users,
  createUser,
  editUser
}
